module.exports = __webpack_public_path__ + "img/1503371755.f88e6694.jpg";